export const APP_NAME = "Mole";
export const PERSIST_STORE_NAME = "admin";
export const REDIRECT_URL_KEY = "redirectUrl";
export const dateFormat = "YYYY-MM-DD HH:mm:ss";
